/** @jsx jsx */
import React from 'react';
import AKBadge from '@atlaskit/badge';
import { css, jsx } from '@emotion/react';
const badgeStyles = css({
  alignItems: 'center',
  display: 'inline-flex'
});

/**
 * A base element that displays a visual indicator for a numeric value
 * @internal
 * @see StoryPoints
 * */

const AtlaskitBadge = ({
  value,
  name,
  overrideCss,
  testId = 'smart-element-atlaskit-badge'
}) => {
  if (!value) {
    return null;
  }
  return jsx("span", {
    css: [badgeStyles, overrideCss],
    "data-fit-to-content": true,
    "data-smart-element": name,
    "data-smart-element-atlaskit-badge": true,
    "data-testid": testId
  }, jsx(AKBadge, null, value));
};
export default AtlaskitBadge;